import FileSaver from 'file-saver';
import axios from 'axios';
import 'json.date-extensions/json.date-extensions.js';

export const apiGetCall = (url, options = {}) => {
  return apiCall(url, options);
}

export const apiDeleteCall = (url, options = {}) => {
  let newOptions = {...options, method: 'delete'};
  return apiCall(url, newOptions);
}

export const apiPostCall = (url, body, options = {}) => {
  let newOptions = {...options, method: 'post', data:body};
  return apiCall(url, newOptions);
}

export const apiPutCall = (url, body, options = {}) => {
  let newOptions = {...options, method: 'put', data:body};
  return apiCall(url, newOptions);
}

export const isResultOk = (obj, notifyErrorhandler, single = false) => {
  if ((obj != null) && (obj.error != undefined)){
      if (notifyErrorhandler){
        if (single){
          notifyErrorhandler(obj);
        }else{
          notifyErrorhandler([obj]);
        }        
      }      
      return false;
  }
  else if (obj == null){
    return true;
  }
  return obj;
}


const useDetailError = process.env.REACT_APP_DETAILED_API_ERRORS;


export const apiCall = (url, options = {}) => {

  const config = {
    url,
    method: options.method || 'get',
    responseType: options.responseType || 'json',
    headers: options.headers || {},
    transformResponse: [function(data) {
      //console.log("data",data);
      return JSON.parseWithDate(JSON.stringify(data));
    }]
  };
  config.headers['Content-Type'] = options.contentType || 'application/json';

  
  if (options.data) {     
      if (!options.contentType || (config.headers['Content-Type'] === 'application/json')) {
        config.data = JSON.stringify(options.data);
      }
      else {        
        //console.log("contenttype", config.headers['Content-Type']);
        //console.log("send with other than json");
        config.data = options.data;
      }    
  }

  return axios(config)
    .then(response => {               
      return response.data !== undefined ? response.data : response;
    })    
    .catch((e) => {
      // console.log("APICALL response", e);
      let error = {
        status : -1,
        statusText : "No connection",
        message : "-1 (No connection)",        
        detail : "No connection available to url " + config.url,
        description : ""
      };            
      if (e.response){
        error.status = e.response.status;
        error.statusText = e.response.statusText;
        if (e.response.status == 404){
            error.message = "404 (Not found)";
            error.detail = "Service was not found on url " + config.url;
        } else if (e.response.status == 415){
            error.message = "415 (Unsupported Media Type)";
            error.detail = "Check the parameters values sent to url " + config.url;
        } 
      }            
      if ((e.response) && (e.response.data !== undefined)){
        //Usally 400 Bad request
        let body = e.response.data;  
         console.log("error data", e.response.data, useDetailError);
        
        if (body != null && body.error){
          error.message = body.error;
          error.detail = "Service url " + config.url;
          if (useDetailError === true) {            
            error.detail = body.error_details;
          }
          error.description = body.error_description;
        }
        else if (body != null){
          error.message = "400 (Bad request)";
          let text = JSON.stringify(body);          
          error.detail = "Service url " + config.url + "\n" + text;
        }

      }               
      // console.log("Error returned", error);        
      return  {error : error};    
    });
};

export const fetchPDFBinary = (url, filename) => {
  apiCall(url).then(data => {
    if (data !== undefined && data !== null) {
      let ab = base64ToArrayBuffer(data);
      let blob = new Blob([ab], { type: 'application/pdf' });
      FileSaver.saveAs(blob, `${filename}.pdf`);
    }
  });
};

export const dateToISO = (date) => {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;
  return [year, month, day].join('-');
}

export const isoToDate = (dateStr) => {
  return new Date(dateStr);
}


export const saveFile = (fileData, fileName, type ) => {
  let ab = base64ToArrayBuffer(fileData);
  let blob = new Blob([ab], { type: type });
  FileSaver.saveAs(blob, fileName);
}

export const base64ToArrayBuffer = base64 => {
  let binaryString = window.atob(base64);
  let binaryLen = binaryString.length;
  let bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    let ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};
